import {
  GET_GOOD_ORDER_LIST,
  GET_APPS_ORDER_LIST,
  EMPTY_ORDER_LIST,
  GET_GAME_LIST,
} from '../constants/order';

export const getGoodsList = params => ({
  type: GET_GOOD_ORDER_LIST,
  params,
});

export const getAppsList = params => ({
  type: GET_APPS_ORDER_LIST,
  params,
});

export const emptyList = params => ({
  type: EMPTY_ORDER_LIST,
  params,
});

export const getGameList = params => ({
  type: GET_GAME_LIST,
  params,
});
